import type { WindowUsageData } from '../../features/BusinessApps/types'
import { useComputerCountQuery } from './useComputerCountQuery'
import type { TagOfInterestSource, Variables } from './useFilteredWindowUsageQuery'
import { useWindowUsageQuery } from './useWindowUsageQuery'

interface UseTimeStatsQueryResult {
  dataList: WindowUsageData[] | undefined
  dailyComputerCountSum: number | undefined
  isLoadingWindowUsage: boolean
  isLoadingComputerCount: boolean
  error: string | null
}

export const useTimeStatsQuery = (
  tagsOfInterestSource: TagOfInterestSource,
  variables?: Variables | undefined,
): UseTimeStatsQueryResult => {
  const windowUsageQuery = useWindowUsageQuery(tagsOfInterestSource, variables)
  const computerCountQuery = useComputerCountQuery()

  const error = windowUsageQuery.error || computerCountQuery.error

  return {
    dataList: windowUsageQuery.dataList,
    dailyComputerCountSum: computerCountQuery.dailyComputerCountSum,
    isLoadingWindowUsage: windowUsageQuery.isLoading,
    isLoadingComputerCount: computerCountQuery.isLoading,
    error,
  }
}

